import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from './behaviors/keli-binding-behavior.js';

class KeliA extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
<style>
  :host {
    text-decoration: underline;
    cursor: pointer;
    color: var(--keli-a-color);
  }
</style>

<slot></slot>`;
  }

  static get is() {
    return 'keli-a';
  }

  static get properties() {
    return {
      keliControlTypes: {type: Array, value: ['anchor']},
      href: {type: String, scopevar: true}
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.activate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.activate);
  }

  activate(event) {
    if (event instanceof MouseEvent) {
      event.stopPropagation();
    }

    if (!this.href) {
      return;
    }
    if (/^keli:/.test(this.href)) {
      this.dispatchEvent(new CustomEvent('keliAnchorActivated', {
        bubbles: true,
        composed: true,
        detail: {href: this.href, event: event}
      }));
    } else if (/^mailto:/.test(this.href)) {
      window.open(this.href);
    } else {
      window.open(this.href, '_blank');
    }
  }
}

customElements.define(KeliA.is, KeliA);
export {KeliA};
